var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('info-block',{attrs:{"data":_vm.order,"fields":_vm.order && _vm.order.id ? (_vm.order.type === 'prescription' ? _vm.fieldsPrescription :  _vm.fields) : [],"title":"详细信息"}})}
var staticRenderFns = []

export { render, staticRenderFns }